import { axios } from '@vyce/core/src/api';

import {
  CompanyWorkerItem,
  ONBOARDING_MODULE_LABELS,
  OnboardingModuleKey,
  OnboardingRecomputeResponse,
} from '../../types';
import { GetUserData } from '../types';
import config from '../config';

const URL = `${config.gatewayApiUrl}`;

// The recompute body takes the human-readable enum values ('Teams', 'Payroll',
// 'Time & Attendance'), unlike the listing responses which are keyed by
// lowercase teams/pay/time — callers pass keys, the mapping happens here.
const toModuleLabels = (modules?: OnboardingModuleKey[]) =>
  (modules ?? []).map(key => ONBOARDING_MODULE_LABELS[key]);

// Recompute endpoints respond 202 Accepted: the work is asynchronous, there is no progress
// endpoint — re-read the listing/profile after a few seconds. An empty `modules` array means
// recompute all three modules. `triggered[].started: false` is a success (already running).

export const recomputeMyOnboardingRequest = (modules?: OnboardingModuleKey[]) => {
  return axios.post<OnboardingRecomputeResponse>(`${URL}/public/v1/users/me/onboarding/recompute`, {
    modules: toModuleLabels(modules),
  });
};

export const recomputeWorkerOnboardingRequest = (
  companyId: string,
  userId: string,
  modules?: OnboardingModuleKey[]
) => {
  return axios.post<OnboardingRecomputeResponse>(
    `${URL}/public/v1/companies/${companyId}/workers/${userId}/onboarding/recompute`,
    { modules: toModuleLabels(modules) }
  );
};

export const recomputeCompanyOnboardingRequest = (companyId: string, modules?: OnboardingModuleKey[]) => {
  return axios.post<OnboardingRecomputeResponse>(
    `${URL}/public/v1/companies/${companyId}/onboarding/recompute`,
    { modules: toModuleLabels(modules) }
  );
};

export const getWorkerOnboardingRequest = ({ companyId, userId }: GetUserData) => {
  return axios.get<CompanyWorkerItem>(`${URL}/public/v1/companies/${companyId}/workers/${userId}`);
};
